const doc = [({"en":({"js":({"contact_merge_requests":({"confirm_merge_request":({"the_users_were_merged":"The users were merged."})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;